var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkademiaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "100px",
    viewBox: "0 0 637 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M116.7 233.9 L116.7 247.8 C113.9 248.5 111 248.8 108.3 248.8 96.4 248.8 87 242.3 87 228.6 87 216.2 94.6 208.6 106.3 208.6 115.6 208.6 120.7 213.6 123.4 217.1 L121.3 206.3 C116.1 204.9 110.9 204.4 107.3 204.4 88.9 204.4 80.2 216.9 80.2 229.7 80.2 243.9 90.2 253 105.2 253 109.6 253 114.1 252.2 118.1 250.3 L123.1 253.1 123.1 233.9 125.7 228.9 113.7 228.9 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1",
    d: "M191.4 252.4 L187.2 247.5 168.7 205.3 161 205.3 163.7 210.1 146.1 247.6 141.8 252.4 154 252.4 150.9 248.1 157.2 233.3 174 233.3 180.4 248.1 177.6 252.5 191.4 252.5 Z M158.7 229.6 L165.5 213.7 172.4 229.6 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M219 241.4 L219 210.3 222.1 205.3 209.5 205.3 212.6 210.3 212.6 247.3 209.5 252.4 240.3 252.4 243 245.1 C235.8 246.7 227.4 248 219.3 248.5 219.1 246.5 219 244.2 219 241.4 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M563.8 252.4 L559.6 247.5 541 205.3 533.3 205.3 536 210.1 518.4 247.6 514.1 252.4 526.3 252.4 523.2 248.1 529.5 233.3 546.4 233.3 552.7 248.1 549.9 252.5 563.8 252.5 Z M531.1 229.6 L537.9 213.7 544.8 229.6 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M413.4 252.4 L423.6 252.4 397.5 232.1 C409.7 231.4 416 226.3 416 218.7 416 210 409 205.3 394.5 205.3 L379.7 205.3 382.8 210.3 382.8 247.3 379.7 252.4 392.2 252.4 389.1 247.3 389.1 231.5 Z M389.1 216.3 C389.1 214 389.2 211.4 389.4 209 L394.7 209 C404.8 209 409.3 212 409.3 219 409.3 229.2 398.8 229.1 391.8 229.1 L389.2 229.1 389.2 216.3 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M491.8 210.3 L494.6 205.3 485 205.3 485.2 209.4 468.9 243.1 450.7 205.3 443.1 205.3 446.7 212.5 443.5 247.1 438.9 252.4 451.6 252.4 448.2 247.6 449.9 218.8 467.5 253.8 468.4 253.8 485.7 217.1 487.7 247.4 484.3 252.4 498.1 252.4 494.5 247.4 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M276.2 205.3 L260.2 205.3 263.3 210.3 263.3 247.3 260.2 252.4 276.2 252.4 C294.8 252.4 304.1 242.2 304.1 228.3 304.1 214.1 294.2 205.3 276.2 205.3 Z M275.5 248.3 L270 248.4 C269.8 246.4 269.7 244.1 269.7 241.4 L269.7 216.3 C269.7 214.1 269.8 211.7 269.9 209.4 L275.5 209.4 C290.2 209.4 297.2 216.4 297.2 228.8 297.2 240.6 290.5 248.2 275.5 248.3 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M333.8 241.4 L333.8 229.1 C340.6 229.2 349.5 229.6 355.7 230.3 L354.7 225.5 333.9 225.8 333.9 216.2 C333.9 213.9 334 211.4 334.1 209 342.1 209.4 350.2 210.6 357.4 212.3 L354.7 205.3 324.4 205.3 327.5 210.3 327.5 247.3 324.4 252.4 355.4 252.4 358.1 245 C350.8 246.7 342.3 248.1 334.2 248.5 333.9 246.5 333.8 244.2 333.8 241.4 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M222.9 73.3 C219.4 74.3 215.9 75.3 212.5 76.3 212.3 78.4 212.1 80.5 212 82.6 210.9 82.9 209.9 83.3 208.8 83.6 209.4 75.5 210.3 67.5 211.3 59.4 212.5 59 213.7 58.7 215 58.3 220.2 64.6 225.2 71 230 77.4 228.9 77.7 227.9 78 226.8 78.2 225.5 76.6 224.2 75 222.9 73.3 Z M221.1 70.9 C218.8 67.9 216.4 64.8 214 61.9 213.6 65.7 213.2 69.6 212.8 73.4 215.5 72.5 218.3 71.7 221.1 70.9 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    d: "M244.9 63.3 C243.9 64.8 242.9 66.4 241.9 67.9 242.4 70 242.8 72.2 243.3 74.3 242.3 74.5 241.2 74.8 240.2 75 238.6 67.7 236.9 60.4 235.3 53.2 236.4 53 237.5 52.7 238.6 52.5 239.4 56.3 240.3 60.1 241.1 63.9 244.1 59.3 247.3 54.7 250.6 50.1 252 49.8 253.3 49.6 254.7 49.4 252 53.2 249.3 56.9 246.7 60.7 250.9 64.2 254.9 67.7 258.9 71.4 257.6 71.6 256.3 71.8 255 72.1 251.7 69 248.3 66.1 244.9 63.3 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    d: "M281.9 62.2 C278.3 62.6 274.8 63 271.2 63.5 270.7 65.5 270.2 67.6 269.7 69.7 268.6 69.9 267.5 70 266.4 70.2 268.3 62.4 270.5 54.5 272.8 46.7 274.1 46.5 275.3 46.4 276.6 46.3 280.7 53.4 284.5 60.5 288.2 67.7 287.1 67.8 286 67.9 284.9 68 283.9 66 282.9 64.1 281.9 62.2 Z M280.5 59.6 C278.7 56.2 276.9 52.8 275 49.5 273.9 53.2 272.9 56.9 272 60.6 274.8 60.2 277.6 59.9 280.5 59.6 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M317.9 55 C317.9 62 313.3 66.2 306.8 66.4 304 66.5 301.3 66.6 298.5 66.8 298.1 59.3 297.7 51.9 297.2 44.4 300.1 44.2 303.1 44.1 306 44 313.1 43.8 318 48 317.9 55 Z M314.5 55.1 C314.5 49.8 311.3 46.8 306.2 47 304.4 47.1 302.6 47.1 300.8 47.2 301.1 52.7 301.3 58.2 301.6 63.8 303.3 63.7 305.1 63.6 306.8 63.6 311.6 63.4 314.5 60.4 314.5 55.1 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    d: "M345.8 64.4 C345.7 65.4 345.7 66.3 345.6 67.3 340.3 66.9 335 66.6 329.6 66.5 329.8 59 330.1 51.6 330.3 44.1 335.8 44.3 341.4 44.6 346.9 45 346.8 46 346.8 46.9 346.7 47.9 342.3 47.6 337.9 47.3 333.6 47.1 333.5 49.4 333.4 51.6 333.3 53.9 337.4 54.1 341.4 54.3 345.5 54.6 345.4 55.5 345.4 56.5 345.3 57.4 341.3 57.1 337.2 56.9 333.2 56.7 333.1 59 333 61.4 332.9 63.7 337.2 63.8 341.5 64.1 345.8 64.4 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    d: "M385.3 49.7 C384 57 382.7 64.4 381.4 71.7 380.4 71.5 379.4 71.3 378.3 71.2 379.3 65.4 380.3 59.6 381.2 53.8 377.9 57.3 374.7 60.8 371.6 64.3 370.7 64.2 369.9 64 369 63.9 367 59.6 364.9 55.4 362.8 51.1 362.1 56.9 361.4 62.8 360.7 68.6 359.7 68.5 358.7 68.4 357.6 68.2 358.4 60.8 359.2 53.4 360 45.9 361.2 46 362.4 46.2 363.7 46.3 366.2 51.1 368.5 55.9 370.8 60.7 374.3 56.7 377.9 52.8 381.6 48.9 382.8 49.3 384 49.5 385.3 49.7 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    d: "M398.9 52.4 C400 52.6 401.1 52.9 402.2 53.1 400.6 60.4 398.9 67.7 397.3 74.9 396.3 74.7 395.2 74.4 394.2 74.2 395.7 67 397.3 59.7 398.9 52.4 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    d: "M425 76.3 C421.5 75.2 418 74.2 414.6 73.3 413.3 75 412 76.7 410.8 78.4 409.7 78.1 408.7 77.8 407.6 77.6 412.4 71.1 417.5 64.8 422.7 58.5 423.9 58.8 425.2 59.2 426.4 59.6 427.4 67.7 428.2 75.8 428.9 83.8 427.8 83.5 426.8 83.1 425.7 82.8 425.4 80.5 425.2 78.4 425 76.3 Z M424.7 73.3 C424.4 69.5 424 65.7 423.5 61.8 421.1 64.8 418.7 67.8 416.3 70.8 419.2 71.7 421.9 72.5 424.7 73.3 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    d: "M320.9 146.5 C319.6 146.5 318.3 146.1 317.3 145.2 314.4 142.9 310.3 141.7 305.1 141.7 L282.5 141.7 C282 141.7 281.5 141.3 281.5 140.7 281.5 140.1 281.9 139.7 282.5 139.7 L286.5 139.7 286.5 131.1 C286.5 130.6 286.9 130.1 287.5 130.1 L311.4 130.1 C314.7 130.1 317.8 131.6 319.8 134.3 L320.9 135.8 322 134.3 C324 131.6 327.1 130.1 330.4 130.1 L354.3 130.1 C354.8 130.1 355.3 130.5 355.3 131.1 L355.3 139.7 359.3 139.7 C359.8 139.7 360.3 140.1 360.3 140.7 360.3 141.3 359.9 141.7 359.3 141.7 L336.7 141.7 C331.5 141.7 327.4 142.9 324.5 145.2 323.4 146.1 322.2 146.5 320.9 146.5 Z M288.4 139.8 L305.1 139.8 C310.3 139.8 314.5 140.9 317.7 143.1 L319.9 144.6 319.9 140.7 C319.9 136 316.1 132.1 311.3 132.1 L288.4 132.1 Z M330.4 132.2 C325.7 132.2 321.8 136 321.8 140.8 L321.8 144.7 324 143.2 C327.2 141 331.4 139.9 336.6 139.9 L353.3 139.9 353.3 132.3 330.4 132.3 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    d: "M320.9 121 C320.7 121 320.4 120.9 320.2 120.7 319.2 119.7 318 118.9 316.7 118.2 L306.1 112.9 C305.8 112.7 305.6 112.4 305.6 112 L305.6 99.1 287.2 93.8 C286.6 93.6 286.5 93.1 286.5 92.9 286.5 92.7 286.6 92.2 287.2 92 L320.6 82.5 320.9 82.5 321.2 82.5 354.6 92 C355.2 92.2 355.3 92.7 355.3 92.9 355.3 93.1 355.2 93.6 354.6 93.8 L345.8 96.3 345.8 116.7 C345.8 117.2 345.4 117.7 344.8 117.7 344.2 117.7 343.8 117.3 343.8 116.7 L343.8 97 336.2 99.2 336.2 112.1 C336.2 112.5 336 112.8 335.7 113 L325.1 118.3 C323.8 118.9 322.6 119.8 321.6 120.8 321.4 120.9 321.1 121 320.9 121 Z M307.5 111.5 L317.5 116.5 C318.4 116.9 319.2 117.5 320 118 L320.8 118.6 321.6 118 C322.4 117.4 323.2 116.9 324.1 116.5 L334.1 111.5 334.1 99.7 321 103.4 C320.9 103.4 320.8 103.4 320.7 103.4 320.6 103.4 320.5 103.4 320.4 103.4 L307.3 99.7 307.3 111.5 Z M291 93 L320.9 101.5 350.8 93 320.9 84.5 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkademiaLogo);
export default __webpack_public_path__ + "static/media/akademia-logo.9767063d2233f8f8c3eece11ed7811ec.svg";
export { ForwardRef as ReactComponent };